import React from 'react';
import { HashRouter, Route, Switch } from "react-router-dom";

import activities from "./starter"
import Planner from "./Planner/Planner"
import LandingPage from "./LandingPage"
import Hero from "./Hero"
import Intro from "./Intro"

import { slugify } from './helpers/helpers';

class App extends React.Component {
  constructor(props) {
    super(props);

    let stateToLoad = JSON.parse(localStorage.getItem('state'));
    if (stateToLoad == null) {
      this.state = { activities: activities, intro: true};
    } else {
      this.state = stateToLoad;
    }

    this.componentDidUpdate = this.componentDidUpdate.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onClickResetData = this.onClickResetData.bind(this);
    this.addActivity = this.addActivity.bind(this);
    this.addPlanner = this.addPlanner.bind(this);
    this.addTimelineEntry = this.addTimelineEntry.bind(this);
    this.removeActivity = this.removeActivity.bind(this);
    this.removeLastEntry = this.removeLastEntry.bind(this);
    this.removePlanner = this.removePlanner.bind(this);
  }

  componentDidUpdate() {
    localStorage.state = JSON.stringify(this.state);
  }

  onChangeTitle(event, activityIndex) {
    let newState = this.state.activities.slice();
    newState[activityIndex].title = event.target.value;
    this.setState(
      { activities: newState }
    );

    document.title = newState[activityIndex].title;
    window.history.replaceState(newState[activityIndex].title, newState[activityIndex].title, '/' + slugify(newState[activityIndex].title));
  }

  onClickResetData() {
    const alert = window.confirm('Delete all data?');
    alert && this.setState({ title: '', activities: [], count: 0 });
  }

  addActivity(activity, activityIndex) {
    let newState = this.state.activities.slice();
    newState[activityIndex].activities.push(activity);
    this.setState({
      activities: newState
    });
  }

  addPlanner(planner) {
    let newState = this.state.activities.slice();
    newState.push(planner);
    this.setState({
      activities: newState
    });
    this.setState({
      intro: false
    });
  }

  removePlanner(planner) {
    let newState = this.state.activities.slice();
    let newActivities = newState.filter( entry => {
        return entry.title !== planner
    });
    this.setState({
      activities: newActivities
    });

    // remove introduction hero
    if(planner === "Upcoming Math Exam") {
      this.setState({
        intro: false
      });
    }
  }

  removeActivity(activity, activityIndex) {
    let newState = this.state.activities.slice();
    let newActivities = newState[activityIndex].activities.filter( entry => {
        return entry.title !== activity
    });
    newState[activityIndex].activities = newActivities;
    this.setState({
      activities: newState
    });
  }

  removeLastEntry(activity, activityIndex) {
    let newState = this.state.activities.slice();
    const lastEntry = newState[activityIndex].activities.findIndex( entry => {
      return entry.title === activity
    })
    newState[activityIndex].activities[lastEntry].timeline.pop();
    this.setState({
      activities: newState
    });
  }

  addTimelineEntry(entry, currentActivity, activityIndex) {
    let newState = this.state.activities.slice();
    const activityToEditIndex = newState[activityIndex].activities.findIndex( entry =>
      entry.title === currentActivity
    );

    const activityToEdit = newState[activityIndex].activities[activityToEditIndex];

    const checkForEntry = activityToEdit.timeline.some( activity => {
      return activity.date === entry.date
    });

    if (!checkForEntry) {
      // add new timeline entry
      activityToEdit.timeline.push(entry);
    } else {
      // modify last timeline entry
      const length = activityToEdit.timeline.length
      activityToEdit.timeline[length - 1].status = entry.status
    }

    this.setState({
      activities: newState
    });
  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route path="/" exact render={props =>
            <>
              <Hero intro={this.state.intro} />
              <LandingPage
                {...props}
                activities={this.state.activities}
                addPlanner={this.addPlanner}
                removePlanner={this.removePlanner}
                intro={this.state.intro}
              />
              { this.state.intro && <Intro addPlanner={this.addPlanner} /> }
            </>
          }/>
          <Route path="/:id" render={props =>
            <Planner
              {...props}
              activities={this.state.activities}
              onChangeTitle={this.onChangeTitle}
              addTimelineEntry={this.addTimelineEntry}
              removeActivity={this.removeActivity}
              removeLastEntry={this.removeLastEntry}
              addActivity={this.addActivity}
            />
          }/>
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
